// utils/getRowClassName.js

export const getRowClassName = (params) => {
  const theme = params.row.theme;
  const themesMatin = ["SweetItem", "Salé", "Boisson (Matin)"];
  const themesMidi = ["Apéro", "Entrée", "Plat", "Dessert", "Boisson (Midi/Soir)"];

  if (themesMatin.includes(theme)) return "theme-matin";
  if (themesMidi.includes(theme)) return "theme-midi";
  return "theme-custom";
};
